<template>
  <div class="growth-body">
    <GrowthCard
      :imageSrc="imageOne"
      title="What is Decoupled Growth?"
      text="Decoupled growth refers to the ability of a business to expand its operations, increase
profitability, and enhance market presence without a corresponding increase in resource use.
This approach enables brands to maintain or even increase their growth trajectory while
reducing their ecological footprint."
    />
    <GrowthCard
      :imageSrc="imageTwo"
      title="The Future of Growth"
      text="Wecobi envisions a future where brands can achieve significant market growth without contributing to the growing environmental crises. By embracing decoupled growth, businesses can scale sustainably, ensuring that their success contributes positively to the planet rather than depleting its resources. This commitment to decoupled growth is at the heart of Wecobi’s mission, guiding our efforts to redefine how businesses grow in the modern world."
    />
  </div>
</template>

<script>
import GrowthCard from "./ReusableComponents/GrowthCard.vue";
import DecoupledGrowth from "../../../assets/sustainability/DecoupledGrowth.png";
import FutureGrowth from "../../../assets/sustainability/FutureGrowth.png";

export default {
  name: "Growth",
  components: {
    GrowthCard,
  },
  data: function () {
    return {
      imageOne: DecoupledGrowth,
      imageTwo: FutureGrowth,
    };
  },
};
</script>

<style scoped>
.growth-body {
  width: 100%;
  display: flex;
  gap: 20px;
  justify-content: space-between;
}
@media (max-width: 588px) {
  .growth-body {
    flex-direction: column;
  }
}
</style>
